import { ORDERS_FETCHED } from "./RaasOrdersListingScreenActionTypes";

export const initialState = {
  orders: [],
  statusConstants: undefined, 
  orderTypes: undefined,
  userInfo: undefined,
};


const SellOrdersScreenReducer = (state = initialState, action) =>{
  switch (action.type) {
    
    case ORDERS_FETCHED:
      var newState = {...state}
      newState.orders = action.orders;
      newState.statusConstants = action.statusConstants;
      newState.orderTypes = action.orderTypes;
      newState.userInfo = action.userInfo;
      return newState;

    default:
      return state;
  }
};

export default SellOrdersScreenReducer;